import { getInvestmentGroup } from '@/lib/investments'

export const applyQuickFilter = (data, quickFilter) => {
    if (data) {
        switch (quickFilter) {
            case 'public':
                return data.entityType === 'Public Company'
            case 'private':
                return (
                    data.entityType !== 'Government' &&
                    data.entityType !== 'College/University' &&
                    data.entityType !== 'Public Company'
                )
            case 'govedu':
                return data.entityType === 'Government' || data.entityType === 'College/University'
            case 'early_stage':
                return (
                    ['Pre-Seed', 'Seed', 'Series A'].includes(
                        getInvestmentGroup(data.lastFundingRoundInvestmentType)
                    ) && ['1-10', '11-50', '51-100', '101-250'].includes(data.employeeCount)
                )
            case 'competitors':
                return data.isCompetitor
            case 'acquisition':
                return data.isAcquisitionTarget
            case 'potential_buyers':
                return data.isPotentialBuyer
            default:
                return true
        }
    }
    return true
}
